// errorModalSlice.ts
import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    visible: false,
    message: ''
};
const errorModalSlice = createSlice({
    name: 'errorModal',
    initialState,
    reducers: {
        showErrorModal(state, action) {
            state.visible = true;
            state.message = action.payload;
        },
        hideErrorModal(state) {
            state.visible = false;
            state.message = '';
        }
    }
});
export const { showErrorModal, hideErrorModal } = errorModalSlice.actions;
export default errorModalSlice.reducer;
